import React, { useContext, useEffect, useState } from 'react';
import { notification } from 'antd';
import Colors from '../../../../constants/Colors.js';
import { AppContext } from 'App.context';
import { ApiContext } from 'utils/networking/Api.context';
import hbxConstants from '../hbxConstants.js';
import constants from 'utils/constants.js';

export default function useHbxAutoInvoice() {
  const { API } = useContext(ApiContext);

  const {
    appState,
    appActions: { translate, getSelectedHotel },
  } = useContext(AppContext);

  const [state, setState] = useState({
    isLoading: false,
    isActive: false,
    dataSource: {
      items: [],
      totalItems: 0,
      totalPages: 0,
      currentPage: 0,
      pageSize: 10,
    },
    expandedRow: null,
    IHClientID: null,
    AdviceDisableProduct: false,
    clientChannelID: null,
    suscription: null /* null | active | requested */,
    pmsNotPermit: null,
    selectedOptionConnection: null,
    hotelFiles: [],
    connectionOptions: [],
  });

  useEffect(() => {
    const fetchConfig = async () => {
      const options = [
        { label: translate('hbxProducts.invoiceSftpConfig'), value: 'SFTP' },
        { label: translate('hbxProducts.invoiceS3Config'), value: 'S3' },
        { label: translate('hbxProducts.invoiceApiConfig'), value: 'API' },
      ];

      const provider = await actions.getProvider();

      let selected = null;
      switch (provider) {
        case constants.BOOKING_PROVIDER.SFTP:
          selected = 'SFTP';
          break;
        case constants.BOOKING_PROVIDER.S3:
          selected = 'S3';
          break;
        default:
          selected = 'API';
      }

      updateState({ selectedOptionConnection: selected, connectionOptions: options });
      actions.getHbxSuscriptionStatus();
      actions.loadProduct();
    };
    fetchConfig();
  }, [state.dataSource.currentPage, state.filters, appState.selectedHotel]);

  const actions = {
    getProvider: async () => {
      try {
        const invoiceSFTP = await API.getInvoiceSFTP(getSelectedHotel()?.key);
        return invoiceSFTP?.sftpCredentials?.provider
          ? invoiceSFTP?.sftpCredentials?.provider
          : null;
      } catch (err) {
        console.warn(err);
      }
    },
    getHbxSuscriptionStatus: () => {
      updateState({ isLoading: true });

      API.getHbxSuscriptionStatus({
        hotelId: getSelectedHotel()?.key,
        nameProduct: 'hbx_invoicing',
      }).then(res => {
        updateState({ suscription: res });
      });

      API.pmsHotelsRequest()
        .then(res => {
          const hotel = res?.find(h => h?.id === getSelectedHotel()?.id);
          if (!hbxConstants.AUTOINV_PMS_PERMIT.includes(hotel?.pmsCheckin)) {
            updateState({ pmsNotPermit: hotel?.pmsCheckin });
          }
        })
        .catch(err => {
          console.warn(err);
        });

      API.salesChannelsRequest(
        state.dataSource?.currentPage,
        state.dataSource?.pageSize,
        {},
        null,
        getSelectedHotel()
      ).then(data => {
        let client = null;
        data?.items?.map(item => {
          if (item?.clients?.find(client => client?.client_id === 24)) {
            client = item.clients.find(client => client.client_id === 24);
          }
        });
        if (client?.id) {
          updateState({ IHClientID: client.id, isActive: !!client.enabled });
        }
      });
    },

    loadProduct: () => {
      const data = { items: [{ hotel: getSelectedHotel()?.name, client: 'Invoice Automation' }] };
      updateState({ dataSource: data, isLoading: false });
    },

    getStateTextColor: () => {
      if (state.isActive) {
        return Colors.greenHotelIntegratedText;
      } else {
        return Colors.redDesactivedText;
      }
    },

    getStateBackgroundColor: () => {
      if (state.isActive) {
        return Colors.greenHotelIntegratedBg;
      } else {
        return Colors.redDesactivedBg;
      }
    },

    getStateString: () => {
      if (state.isActive) {
        return translate('states.enabled');
      } else {
        return translate('states.disabled');
      }
    },

    openInfoModal: () => {
      updateState({ isModalOpen: true });
    },

    closeInfoModal: () => {
      updateState({ isModalOpen: false });
    },

    handleSelectConnection: async option => {
      updateState({ selectedOptionConnection: option });
    },

    changeOTAState: async value => {
      updateState({ isLoading: true });
      const hotelData = await API.getOneHotel({ hotelId: getSelectedHotel()?.key });

      if (value) {
        API.sendOptIn(
          getSelectedHotel()?.key,
          hotelData.atlasId,
          hbxConstants.AUTOINV_PRODUCT,
          24,
          state.IHClientID
        )
          .then(res => {
            updateState({ isActive: value, IHClientID: res.newIHClientHotelId });

            let message = translate('hbxProducts.enableProduct');
            message = message.replace('%s', 'Invoice Automation');
            notification.success({
              message: message,
            });
          })
          .catch(err => {
            notification.error({
              message: translate('hbxProducts.errorMessage'),
            });
          });
      } else {
        API.sendOptOut(
          getSelectedHotel()?.key,
          hotelData.atlasId,
          hbxConstants.AUTOINV_PRODUCT,
          state.IHClientID
        )
          .then(() => {
            updateState({ isActive: value });
            let message = translate('hbxProducts.disableProduct');
            message = message.replace('%s', 'Invoice Automation');
            notification.success({
              message: message,
            });
          })
          .catch(err => {
            notification.error({
              message: translate('hbxProducts.errorMessage'),
            });
          });
      }
      updateState({ isLoading: false });
    },

    setAdviceDisableProduct: show => {
      updateState({ AdviceDisableProduct: show });
    },

    onExpanded: rowId => {
      if (state.expandedRow === rowId) {
        updateState({ expandedRow: null });
      } else {
        updateState({ expandedRow: rowId });
      }
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
}
